import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class FirTrueupTaxesService {

  constructor(private http: HttpClient) { }

  /**
   * Get entities for LEID search
   * AngularJS JsonObjectFactory.getJSONObj merges: GlobalService.globalParams + filterParams + specificParams
   */
  getEntities(
    baseUrl: string,
    tax_year: string,
    scenario: string,
    jcd_key: number,
    search_string: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    
    // Specific params for this API call
    const specificParams: any = {
      action_code: 'xmgv96',
      tax_year: tax_year,
      scenario: scenario,
      jcd_key: jcd_key,
      search_string: search_string
    };
    
    // Match AngularJS JsonObjectFactory.getJSONObj merge pattern
    let params = _.merge(
      {},
      globalService?.globalParams || {},
      filterParams || {},
      specificParams
    );
    delete params.checkLockedbj;
    
    // Convert to HttpParams for query string
    let httpParams = new HttpParams();
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value !== null && value !== undefined) {
        httpParams = httpParams.append(key, String(value));
      }
    });
    
    return this.http.get<any>(url, { params: httpParams, withCredentials: true });
  }

  /**
   * Get TLC Amount
   * AngularJS JsonObjectFactory.getJSONObj merges: GlobalService.globalParams + filterParams + specificParams
   */
  getTLCAmount(
    baseUrl: string,
    tax_year: string,
    combination_keys: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    
    // Specific params for this API call
    const specificParams: any = {
      action_code: 'yu78eh',
      tax_year: tax_year,
      combination_keys: combination_keys
    };
    
    // Match AngularJS JsonObjectFactory.getJSONObj merge pattern
    let params = _.merge(
      {},
      globalService?.globalParams || {},
      filterParams || {},
      specificParams
    );
    delete params.checkLockedbj;
    
    // Convert to HttpParams for query string
    let httpParams = new HttpParams();
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value !== null && value !== undefined) {
        httpParams = httpParams.append(key, String(value));
      }
    });
    
    return this.http.get<any>(url, { params: httpParams, withCredentials: true });
  }

  /**
   * Get FIR Tax Amount
   * AngularJS JsonObjectFactory.getJSONObj merges: GlobalService.globalParams + filterParams + specificParams
   */
  getFirTaxAmt(
    baseUrl: string,
    tax_year: string,
    combination_keys: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    
    // Specific params for this API call
    const specificParams: any = {
      action_code: 'ivwted',
      tax_year: tax_year,
      combination_keys: combination_keys
    };
    
    // Match AngularJS JsonObjectFactory.getJSONObj merge pattern
    let params = _.merge(
      {},
      globalService?.globalParams || {},
      filterParams || {},
      specificParams
    );
    delete params.checkLockedbj;
    
    // Convert to HttpParams for query string
    let httpParams = new HttpParams();
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value !== null && value !== undefined) {
        httpParams = httpParams.append(key, String(value));
      }
    });
    
    return this.http.get<any>(url, { params: httpParams, withCredentials: true });
  }

  /**
   * Get currencies for selected year
   * AngularJS JsonObjectFactory.getJSONObj merges: GlobalService.globalParams + filterParams + specificParams
   */
  getCurrencies(
    baseUrl: string,
    tax_year: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    
    // Specific params for this API call
    const specificParams: any = {
      action_code: '3ucwjb',
      tax_year: tax_year
    };
    
    // Match AngularJS JsonObjectFactory.getJSONObj merge pattern
    let params = _.merge(
      {},
      globalService?.globalParams || {},
      filterParams || {},
      specificParams
    );
    delete params.checkLockedbj;
    
    // Convert to HttpParams for query string
    let httpParams = new HttpParams();
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value !== null && value !== undefined) {
        httpParams = httpParams.append(key, String(value));
      }
    });
    
    return this.http.get<any>(url, { params: httpParams, withCredentials: true });
  }

  /**
   * Get tax years for entity
   * AngularJS JsonObjectFactory.getJSONObj merges: GlobalService.globalParams + filterParams + specificParams
   */
  getTaxyears(
    baseUrl: string,
    tax_year: string,
    leid: string,
    cdr_no: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    
    // Specific params for this API call
    const specificParams: any = {
      action_code: 'aeihoi',
      tax_year: tax_year,
      selectedEntity: leid,
      selectedCdr: cdr_no
    };
    
    // Match AngularJS JsonObjectFactory.getJSONObj merge pattern
    let params = _.merge(
      {},
      globalService?.globalParams || {},
      filterParams || {},
      specificParams
    );
    delete params.checkLockedbj;
    
    // Convert to HttpParams for query string
    let httpParams = new HttpParams();
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value !== null && value !== undefined) {
        httpParams = httpParams.append(key, String(value));
      }
    });
    
    return this.http.get<any>(url, { params: httpParams, withCredentials: true });
  }

  /**
   * Get existing true up taxes data
   * AngularJS JsonObjectFactory.getJSONObj merges: GlobalService.globalParams + filterParams + specificParams
   */
  getTrueUpTaxes(
    baseUrl: string,
    tax_year: string,
    combination_key: string,
    trans_header_key: string,
    trans_details_key: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    
    // Specific params for this API call
    const specificParams: any = {
      action_code: '29ylov',
      tax_year: tax_year,
      combination_key: combination_key,
      trans_header_key: trans_header_key,
      trans_details_key: trans_details_key
    };
    
    // Match AngularJS JsonObjectFactory.getJSONObj merge pattern:
    // var paramsMerge = _.merge({}, filterParams, _params);
    // var params = _.merge({}, GlobalService.globalParams, paramsMerge);
    let params = _.merge(
      {},
      globalService?.globalParams || {},
      filterParams || {},
      specificParams  // Specific params override merged ones
    );
    
    // Remove checkLockedbj like AngularJS does
    delete params.checkLockedbj;
    
    // Convert to HttpParams for query string
    let httpParams = new HttpParams();
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value !== null && value !== undefined) {
        httpParams = httpParams.append(key, String(value));
      }
    });
    
    return this.http.get<any>(url, { params: httpParams, withCredentials: true });
  }

  /**
   * Save true up taxes data
   * Matches AngularJS trueUpTaxesFactory.save() exactly
   */
  save(
    baseUrl: string,
    data: any,
    isDelete: boolean,
    lockObj: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const action_code = isDelete ? '7pkdzh' : 'r1zyw7';
    const url = `${baseUrl}/saveJsonObject?action_code=${action_code}`;
    
    // CRITICAL: jsonSettings must use data.COMBINATION_KEYS (from selectedEntity.COMBINATION_KEY)
    // This matches the AngularJS pattern exactly
    const jsonSettings = [{
      tax_year: data.TAX_YEAR,
      combination_keys: data.COMBINATION_KEYS  // This is the selected entity's COMBINATION_KEY
    }];
    
    const jsonObj = JSON.stringify(data);
  
    let globalParamsWithLock = { ...(globalService?.globalParams || {}) };
    
    if (lockObj && lockObj.lockingObj) {
      if (!_.isEmpty(lockObj.lockingObj)) {
        globalParamsWithLock.checkLockedbj = JSON.stringify(lockObj.lockingObj);
        console.log('Set checkLockedbj from lockObj:', globalParamsWithLock.checkLockedbj);
      } else {
        // If lockingObj is empty, remove checkLockedbj (like AngularJS modalLockFilters does)
        delete globalParamsWithLock.checkLockedbj;
        console.log('Deleted checkLockedbj (lockingObj is empty)');
      }
    } else {
      console.log('lockObj or lockingObj not provided, using existing checkLockedbj:', globalParamsWithLock.checkLockedbj);
    }
    
    let params: any = {};
    params = _.merge(params, globalParamsWithLock);
    params = _.merge(params, filterParams);
    
    // CRITICAL: Add jsonSetting and jsonObj using _.extend like AngularJS
    // params = _.extend({jsonSetting: JSON.stringify(jsonSettings)}, params);
    // params = _.extend({jsonObj:jsonObj}, params);
    params = _.extend({ jsonSetting: JSON.stringify(jsonSettings) }, params);
    params = _.extend({ jsonObj: jsonObj }, params);
    
    // Convert to URLSearchParams for application/x-www-form-urlencoded
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });
    
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  /**
   * Save tax true up signoff
   */
  saveTaxTrueUpSignoff(
    baseUrl: string,
    rowData: any,
    colData: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=l6zqof`;
    
    const jsonObj = [{
      combination_key: rowData.COMBINATION_KEY,
      chart_key: rowData.CHART_KEY,
      trans_header_key: rowData.SIGNOFF_TRANS_HEADER_KEY === undefined ? 0 : rowData.SIGNOFF_TRANS_HEADER_KEY,
      signoff_y_n: rowData.SIGNOFF_Y_N,
      currency: rowData.PARENT_FUNCTIONAL_CURRENCY,
      amount: rowData[colData.map],
      column_name: colData.map,
      GROUP_TRANS_KEY: rowData.GROUP_TRANS_KEY
    }];
    
    const jsonSettings = [{
      combination_key: rowData.COMBINATION_KEY,
      tax_year: rowData.TAX_YEAR
    }];
    
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    
    params = _.extend({
      jsonObj: JSON.stringify(jsonObj),
      jsonSetting: JSON.stringify(jsonSettings)
    }, params);
    
    // Convert to URLSearchParams for application/x-www-form-urlencoded
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });
    
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}

